import { render, staticRenderFns } from "./Participant.vue?vue&type=template&id=59ec592c&"
import script from "./Participant.vue?vue&type=script&lang=ts&"
export * from "./Participant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports